import HomeTile from "./HomeTile";
import { HomeTileData } from "../const/data";
import PageMeta from "./PageMeta";

const HomePageContainer = () => {
  return (
    <div className="tiles">
      <PageMeta
        description="My name is Michał Nierebiński and I'm an experienced software engineer who's not afraid of handling full-stack. I lead an iOS development team."
      />
      {HomeTileData.map((item) => (
        <HomeTile
          key={item.header}
          index={item.header}
          header={item.header}
          subheader={item.subheader}
          specialClassName={item.specialClassName}
          content={item.content ? item.content : []}
          alternativeImageText={item.image ? item.image.alt : undefined}
          imageFile={item.image ? item.image.file : undefined}
          linkURL={item.image ? item.image.linkURL : undefined}
          linkTitle={item.image ? item.image.linkTitle : undefined}
          openInNewWindow={item.image ? item.image.openInNewWindow : false}
          customClassName={item.image.className}
        />
      ))}
    </div>
  );
};

export default HomePageContainer;
